import axios from "_u/axios"

// 日志-数据操作记录表列表
export const optrList = (body) => {
    return axios.post("api/log/optr/queryList", body)
}